import React from 'react';
import styled from 'styled-components';
import { border, color, flexbox, fontFamily, space, layout, position, typography } from 'styled-system';
import { Flex } from './containers';

const Style = styled.button`
${border}
${fontFamily}
${layout}
${position}
${flexbox}
${space}
${color}
color: ${props => props.theme.colors.accent};
span {
    font-size: ${props => props.theme.fontSizes[2]}px;
}
.inner {
    --duration: 200ms;
    clip-path: circle(0%);
    opacity: 0;
    color: white;
    text-align: center;
    transition: clip-path var(--duration) ease-in-out, opacity var(--duration) linear, background 0.6s;
}
:hover {
    .inner {
        background: ${props => props.theme.colors.accent} radial-gradient(circle, transparent 1%, ${props => props.theme.colors.accent} 1%) center/15000%;
        clip-path: circle(100%);
        opacity: 1;
    }
}
a:active > .inner {
    background-color: ${props => props.theme.colors.accentLight};
    background-size: 100%;
    transition: background 0s;
}
`;

export const LinkButton = ({children, link, text}) =>
<Style
mr={[3]}
my={[1]}
border="solid"
bg="white"
display="flex"
alignItems="center"
position="relative"
px={[2,3,4]}
py={[2,3]}
fontFamily="body"
textAlign="center"
css={{textTransform: 'uppercase'}}
>
    <span>{text}</span>
    {children}
    <a href={link}><Flex className="inner" alignItems="center" justifyContent="center" height="100%" width="100%" position="absolute" py={[2,3]} bottom="0" left="0" zIndex={99}>
        <span>{text}</span>
        {children}
    </Flex></a>
</Style>

export const Tag = styled.li`
${border}
${space}
${color}
${typography}
a {
  background-color: ${props => props.theme.colors.accent};
  color: #fff;
  padding: 1rem;
  display: inline-block;
  text-transform: uppercase;
}
`